export default __webpack_public_path__ + "static/media/action-play_lightGray1.746a2ec7.svg";